import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { linksForPath } from '../../utils/internalLinks';
import { publicAccent } from './publicColors';

const Nav = styled.nav`
  margin-top: 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.45rem;
`;

const Item = styled(Link)`
  color: ${publicAccent};
`;

/** Same neighbours the static shell exposes to crawlers that do not run JavaScript. */
const RelatedPages = (): JSX.Element | null => {
  const { pathname } = useLocation();
  const links = linksForPath(pathname);
  if (links.length < 2) return null;

  return (
    <Nav aria-label="Related pages">
      {links.map((link) => (
        <Item key={link.href} to={link.href}>
          {link.label}
        </Item>
      ))}
    </Nav>
  );
};

export default RelatedPages;
